import { useLang } from '@/i18n';
import css from './index.module.scss';

interface ItfItem {
    text: string;
    link: string;
    href: string;
}

export default function PSTIStatement() {
    const { t } = useLang('psti');
    const items: ItfItem[] = [
        {
            text: t('item1_text'),
            link: t('item1_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775713922897/Statement%20of%20compliance%20for%20UK%20PSTI_EFBX100%20(Portable%20Refrigerator%20(EcoFlow%20GLACIER)%20).pdf',
        },
        {
            text: t('item2_text'),
            link: t('item2_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714331085/Statement%20of%20compliance%20for%20UK%20PSTI_EFD310%20(EcoFlow%20DELTA%20Max%20(2000))%20.pdf',
        },
        {
            text: t('item3_text'),
            link: t('item3_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714333542/Statement%20of%20compliance%20for%20UK%20PSTI_EFD311%20(ECOFLOW%20DELTA%20Max%20(1600)).pdf',
        },
        {
            text: t('item4_text'),
            link: t('item4_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714333332/Statement%20of%20compliance%20for%20UK%20PSTI_EFD330%20(EcoFlow%20DELTA%202).pdf',
        },
        {
            text: t('item5_text'),
            link: t('item5_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714331461/Statement%20of%20compliance%20for%20UK%20PSTI_EFD330-EB%20(EcoFlow%20DELTA%202%20Smart%20Extra%20Battery).pdf',
        },
        {
            text: t('item6_text'),
            link: t('item6_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714331268/Statement%20of%20compliance%20for%20UK%20PSTI_EFD350%20(EcoFlow%20DELTA%202%20Max).pdf',
        },
        {
            text: t('item7_text'),
            link: t('item7_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714333097/Statement%20of%20compliance%20for%20UK%20PSTI_EFD500%20(EcoFlow%20DELTA%20Pro).pdf',
        },
        {
            text: t('item8_text'),
            link: t('item8_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714333824/Statement%20of%20compliance%20for%20UK%20PSTI_EFD500-EB%20(EcoFlow%20DELTA%202%20Max%20Smart%20Extra%20Battery).pdf',
        },
        {
            text: t('item9_text'),
            link: t('item9_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714331652/Statement%20of%20compliance%20for%20UK%20PSTI_EFD500-EB%20(EcoFlow%20DELTA%20Pro%20Smart%20Extra%20Battery).pdf',
        },
        {
            text: t('item10_text'),
            link: t('item10_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714731161/Statement%20of%20compliance%20for%20UK%20PSTI_EFD610%20(EcoFlow%20RIVER%202%20Max).pdf',
        },
        {
            text: t('item11_text'),
            link: t('item11_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714332801/Statement%20of%20compliance%20for%20UK%20PSTI_EFG200%20(EcoFlow%20Smart%20Generator%20(Dual%20Fuel)).pdf',
        },
        {
            text: t('item12_text'),
            link: t('item12_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714332363/Statement%20of%20compliance%20for%20UK%20PSTI_EFH100%20(Robotic%20Lawn%20Mower%20(EcoFlow%20BLADE))%20.pdf',
        },
        {
            text: t('item13_text'),
            link: t('item13_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714332650/Statement%20of%20compliance%20for%20UK%20PSTI_EFR600%EF%BC%88EcoFlow%20RIVER%202%EF%BC%89.pdf',
        },
        {
            text: t('item14_text'),
            link: t('item14_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714873143/Statement%20of%20compliance%20for%20UK%20PSTI_EFR620%20(EcoFlow%20RIVER%202%20Pro)%20.pdf',
        },
        {
            text: t('item15_text'),
            link: t('item15_link'),
            href: 'https://websiteoss.ecoflow.com/upload/pdf/1775714331835/Statement%20of%20compliance%20for%20UK%20PSTI_EFWN511-SUK%20(EcoFlow%20Smart%20Plug).pdf',
        },
    ];

    return (
        <div className={`psti ${css.psti}`}>
            <div className="info">
                <h2 className="title">{t('title')}</h2>
                <p className="desc">{t('desc')}</p>
            </div>
            <table className="items">
                <thead>
                    <tr>
                        <th>{t('item_name')}</th>
                        <th>{t('item_desc')}</th>
                    </tr>
                </thead>
                <tbody>
                    {items?.map((item: ItfItem, i: number) => (
                        <tr className="item" key={i}>
                            <td>{item.text}</td>
                            <td>
                                <a href={item.href} download={true} aria-label={item.link}>
                                    {item.link}
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
